import { writable } from 'svelte/store';
import { localStore } from '$lib/utils/localStore';

export const theme = localStore('theme', '');
export const height = localStore('height', 0);
export const width = localStore('width', 0);

const imageX = 3000;
const imageY = 900;
export const slideData = writable({
	current: 0
});

export const slides = writable([
	{
		id: 0,
		name: 'Graywater Setup',
		location: 'Diamante Valley, Costa Rica',
		participation: 30,
		benefits: ['conserves water', 'provides local education', 'mulch basins digest the run-off'],
		img: `https://place.dog/${imageX}/${imageY}`
	},

	{
		id: 1,
		name: 'Aquaponic cultures',
		location: 'Trinidad, CA, USA',
		participation: 2,
		benefits: ['conserves water', 'provides local education', 'grows some fantastic veggies'],
		img: `https://loremflickr.com/${imageX}/${imageY}`
	},

	{
		id: 2,
		name: 'Future Economies',
		location: 'The world',
		participation: 100000,
		benefits: ['access to resources', 'bank the unbanked', 'decentralize data ownership'],
		img: `https://placekitten.com/${imageX}/${imageY}`
	}
]);
